import React, { useRef, useEffect } from 'react';

// Fully uncontrolled input - no real-time state updates, only on tab switch
const StableInput = ({ label, initialValue, onChange, type = 'text', placeholder, tabKey, settingKey }) => {
  const inputRef = useRef(null);
  const lastTabKey = useRef(null);
  const currentValue = useRef('');
  
  // Only sync from server when switching tabs or first mount
  useEffect(() => {
    if (inputRef.current && initialValue !== undefined) {
      // Sync if this is first mount or if we switched to a different tab
      const shouldSync = !lastTabKey.current || lastTabKey.current !== tabKey;
      
      if (shouldSync) {
        console.log(`StableInput "${label}" syncing from server:`, initialValue, `(tab: ${tabKey})`);
        inputRef.current.value = String(initialValue);
        currentValue.current = String(initialValue);
        lastTabKey.current = tabKey;
      }
    }
  }, [initialValue, label, tabKey]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    currentValue.current = newValue;
    // Don't call onChange during typing - this prevents parent re-renders
    console.log(`StableInput "${label}" local change:`, newValue);
  };

  // Expose methods and data for saving
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.getCurrentValue = () => currentValue.current || inputRef.current.value;
      inputRef.current.getSettingKey = () => settingKey;
      inputRef.current.getType = () => type;
      inputRef.current.setAttribute('data-setting-key', settingKey || '');
    }
  }, [settingKey, type]);

  return (
    <div>
      <label className="label">{label}</label>
      <input
        ref={inputRef}
        type={type}
        onChange={handleChange}
        className="input"
        placeholder={placeholder}
        autoComplete="off"
        defaultValue=""
      />
    </div>
  );
};

export default StableInput;